import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";

export const formGroupTaskInit = (dFecha?:string) => {
    return new FormGroup({
        dFecha_Registro: new FormControl(dFecha),
        nMinutos: new FormControl(60),
        nCantidad: new FormControl(null, Validators.required),
        sCodigo_Tipo_Actividad: new FormControl(null),
        sCodigo_Proyecto: new FormControl(null),
        sCodigo_Requerimiento: new FormControl(null),
        sCodigo_Categoria: new FormControl(null),
        sCodigo_Tipo_Horas: new FormControl(null, Validators.required),

        sNombre_Tipo_Actividad: new FormControl(null),
        sNombre_Proyecto: new FormControl(null),
        sNombre_Categoria: new FormControl(null),
        sNombre_Tipo_Horas: new FormControl(null),
        sNombre_Requerimiento: new FormControl(null),

        sDetalle: new FormControl(null, Validators.required),
        sAnotaciones: new FormControl(null),
        dHora_Inicio: new FormControl(null),
        dHora_Fin: new FormControl(null),
        dFecha_Inicio: new FormControl(null),
        dFecha_Fin: new FormControl(null),

    });
}
